import distinctObjects from '../utility/distinctObjects'

function getIceDriftFilter (items) {
  const property_array = items.map(item => item.properties)
  const timestamps = distinctObjects(property_array, 'timestamp2').map(item => item.timestamp2)
  return timestamps
}

export default getIceDriftFilter



// WEBPACK FOOTER //
// ./src/utility/getIceDriftFilter.js